import { useCallback } from 'react'

import {
  type CoreBookingStatus,
  type CoreBookingPaymentRentalStatus,
  type CoreBookingPaymentDepositStatus,
} from '@flecto/types'
import {
  type FilterValue,
  type DateRange,
} from '@flecto/ui/@shared/Filters/components/multi-select/filterTypeConfig'

export function useProcessBookingFilters() {
  const processBookingFilters = useCallback(function (
    filtersApplied: FilterValue[]
  ): Record<string, unknown> {
    const filters: Record<string, unknown> = {}
    filtersApplied.forEach(({ key, value }) => {
      switch (key) {
        case 'status':
          filters.status = value as CoreBookingStatus[]
          break
        case 'customers':
          filters.customer_ids = Array.isArray(value) ? value.map(Number) : []
          break
        case 'products':
          filters.item_ids = Array.isArray(value) ? value.map(Number) : []
          break
        case 'payment-status':
          filters.payment_rental_status =
            value as CoreBookingPaymentRentalStatus[]
          break
        case 'deposit-status':
          filters.payment_deposit_status =
            value as CoreBookingPaymentDepositStatus[]
          break
        case 'date-range': {
          const { startDate, endDate, startTime, endTime } = value as DateRange

          filters.from =
            startDate && startTime ? `${startDate}T${startTime}` : null
          filters.to = endDate && endTime ? `${endDate}T${endTime}` : null
          break
        }
        default:
          break
      }
    })
    return filters
  }, [])

  return { processBookingFilters }
}
